import React from "react";
import Header from "../components/site/Header";
import Hero from "../components/site/Hero";
import About from "../components/site/About";
import PracticeAreas from "../components/site/PracticeAreas";
import Team from "../components/site/Team";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="min-h-screen bg-cream-100">
      <Header />
      <main>
        <Hero />
        <About />
        <PracticeAreas />
        <Team />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
